/* eslint-disable react/display-name */
import { memo } from 'react';

import { lazyLoad } from 'utils/loadable';

import { AdministrationRouting } from './administration.routing';
export const administrationComponent = memo(() => {
  return (
    <>
      <div></div>
      <AdministrationRouting />
    </>
  );
});

export const AdministrationModule = lazyLoad(
  () => import('./administration.module'),
  (module) => module.administrationComponent
);
